
const arrayToBreadCrumbs = (array) => {
  return array.map((pair) => ({
    title: pair[0],
    link: pair.length > 1 ? pair[1] : "",
  }));
};

export default arrayToBreadCrumbs;
